module.exports = __webpack_public_path__ + "img/logo_sbux.1de6f775.png";